<template>
  <div id="app">
    <div v-loading="loading" :style="{'minHeight':minHeight}">
      <template v-if="config_info">
        <!-- <template v-if="config_info.site_open==='1'"> -->
          <template v-if="showPC">
            <transition name="router-fade" mode="out-in">
              <!-- <keep-alive> -->
                <router-view></router-view>
              <!-- </keep-alive> -->
            </transition>
          </template>
        <!-- </template> -->
        <!-- <template v-else>
          <div>{{config_info.close_tips}}</div>
        </template> -->
      </template>
    </div>
  </div>
</template>

<script>
  import { configResource } from '@/resource/resource'
  import { addCookie, getCookie } from '@/common/js/cookies'
  // import { saveToLocal } from '@/common/js/store'
  import { mapState, mapMutations } from 'vuex'

  const ERR_OK = 0
  export default {
    name: 'app',
    data () {
      return {
        loading: false,
        minHeight: '974px',
        showPC: false
      }
    },
    computed: {
      ...mapState(['config_info'])
    },
    created () {
      this.pcOnWap()
      this.getNotice()
      this.minHeight = window.innerHeight + 'px'
    },
    methods: {
      // 获取站点配置信息
      getNotice () {
        this.loading = true
        configResource.config({ config: 'site_icon,site_logo,site_title,site_notice,site_copyright,service_macao_number,service_philippines_number,service_qq,service_wechat,banner_main,link_main,search_vip,search_e_level,search_r_level,search_price,search_e_up_reward,search_e_week_reward,search_e_month_reward,search_r_up_reward,search_r_month_reward,service_buy,service_repwd_url,service_main_sell_limit,service_sell_limit,service_hot_limit,service_sold_limit,back_color,sale_extend,service_ext_url,service_kefu_info_1,service_kefu_url_1,service_kefu_info_2,service_kefu_url_2,service_macao_number_title,week_salary_status,month_salary_status,recover_description,assess_description,sell_description' }).then(response => {
          response = response.body
          this.loading = false
          if (response.errcode === ERR_OK) {
            this.CONFIG_INFO(response.data)
            document.title = response.data.site_title
            this.getFavicon(response.data.site_icon)
            this.showPC = true
          }
        })
      },
      // 判断是否移动端打开pc站点
      pcOnWap() {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(window.navigator.userAgent)) {
          if (window.location.host.includes('www') && !window.location.host.indexOf('www')) {
            window.location.href = '//' + window.location.host.replace('www', 'm')
          } else {
            window.location.href = '//m.' + window.location.host
          }
          this.showPC = true
        }
      },
      // pc的safari浏览器跨域访问
      handleCORS() {
        if (this.checkBrowser() === 'Safari') {
          if (!getCookie('auth')) { // 24小时内只需执行一次
            let localUrl = window.location.host
            let localApi = this.apiUrl
            let localUrlArr = localUrl.split('.')
            let localApiArr = localApi.split('.')
            let uLength = localUrlArr.length
            let aLength = localApiArr.length
            let isEq = uLength >= 2 && aLength >= 2 && localUrlArr[uLength - 2] === localApiArr[aLength - 2] // 是否相同的一级域名
            if (!isEq) { // safari浏览器跨域访问，则解决safari浏览器不带cookie问题
              addCookie('auth', true, 24)
              window.location.href = this.apiUrl + '/go.php'
            }
          }
        }
      },
      // 检测浏览器类型
      checkBrowser() {
        var explorer = window.navigator.userAgent
        // 判断是否为IE浏览器
        if (explorer.indexOf('MSIE') >= 0) {
          return 'ie'
        } else if (explorer.indexOf('Firefox') >= 0) { // 判断是否为Firefox浏览器
          return 'Firefox'
        } else if (explorer.indexOf('Chrome') >= 0) { // 判断是否为Chrome浏览器
          return 'Chrome'
        } else if (explorer.indexOf('Opera') >= 0) { // 判断是否为Opera浏览器
          return 'Opera'
        } else if (explorer.indexOf('Safari') >= 0) { // 判断是否为Safari浏览器
          return 'Safari'
        } else {
          return 'others'
        }
      },
      // 网站icon
      getFavicon(url) {
        var link = document.createElement('link')
        link.href = url
        link.rel = 'shortcut icon'
        document.head.appendChild(link)
      },
      // 更新vuex状态信息
      ...mapMutations([
        'CONFIG_INFO',
        'CONFIG_FOOT'
      ])
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  #app
    font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif
    font-size 12px
    -webkit-font-smoothing: antialiased
    -moz-osx-font-smoothing: grayscale
    height inherit
  .router-fade-enter-active, .router-fade-leave-active
    transition: opacity .3s
  .router-fade-enter, .router-fade-leave-active
    opacity: 0
</style>



// WEBPACK FOOTER //
// App.vue?283f1129